import "./tab01.css";


import React, { useState, useEffect } from "react";
import { Navigate, useParams, useNavigate, useLocation } from "react-router-dom";
import {db} from '../../../config/firebaseConfig'
import {getDocs, collection, query, where} from 'firebase/firestore'
// 電気
import ModalElectric from './modalElectric/modalElectric';
import TableElectric from "./tableElectric/tableElectric";
// ネットワーク
import ModalNetwork from './modalNetwork/modalNetwork';
import TableNetwork from "./tableNetwork/tableNetwork";
// 空気
import ModalAir from './modalAir/modalAir'
import TableAir from "./tableAir/tableAir";
// 水
import ModalWater from './modalWater/modalWater'
import TableWater from "./tableWater/tableWater";



import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDroplet, faNetworkWired, faBolt, faWind, faPlus } from "@fortawesome/free-solid-svg-icons";
import { data } from "jquery";


const Tab01 = ({ setCanEdit }) => {
    //electric
    const [isElectricModalOpen, setElectricModalOpen] = useState(false);
    const [electricTableData, setElectricTableData] = useState([]);
    //network
    const [isNetworkModalOpen, setNetworkModalOpen] = useState(false);
    const [networkTableData, setNetworkTableData] = useState([]);
    //air 
    const [isAirModalOpen, setAirModalOpen] = useState(false);
    const [airTableData, setAirTableData] = useState([]);
    // water
    const [isWaterModalOpen, setWaterModalOpen] = useState(false);
    const [waterTableData, setWaterTableData] = useState([]);

    const [mode, setMode] =useState('edti')//create or edit
    const { masterID } = useParams(); // URLのパラメータを取得 (id)
    const [selectedData, setSelectedData] = useState(null);
    const location =useLocation();
    const {state} =location;
    const currentProjectID = localStorage.getItem("currentProjectID");

    //新規作成ボタンの場合
    const handleNew= ()=>{
        setMode('create');
        setSelectedData(null);
    }
    //編集ボタンの場合
    const handleEdit= (data, category)=>{
        setMode('edit') ;
        // console.log('edit mode')
        // console.log('row', data)//選択行のデータがtableElectric.jsを介してdataに入る
        setSelectedData(data);//編集対象のデータをセット
        // console.log('tab01.js selectedData', selectedData)
        // カテゴリーに応じて適切なモーダルを開く
        switch (category) {
            case "electric":
                setElectricModalOpen(true);
                break;
            case "network":
                setNetworkModalOpen(true);
                break;
            case "air":
                setAirModalOpen(true);
                break;
            case "water":
                setWaterModalOpen(true);
                break;
            default:
                console.error("不明なカテゴリー: ", category);
                break;
        }
    }

    useEffect(() => {
        if (state?.edit && state?.data && state?.category) {
          handleEdit(state.data, state.category); // ← カテゴリー付きで渡す
        }
      }, [state]);



    //テーブル表示データの取得
    useEffect(() => {
        const categories = [
            { name: "electric", stateSetter: setElectricTableData, collectionName: '01-1_electricTable' },
            { name: "network", stateSetter: setNetworkTableData, collectionName: '02-1_networkTable' },
            { name: "air", stateSetter: setAirTableData, collectionName: '03-1_airTable' },
            { name: "water", stateSetter: setWaterTableData, collectionName: '04-1_waterTable' }
        ];

        const fetchTableData = async (category, setState, collectionName) => {
            const newCanEdit = { electric: false, air: false, water: false, network: false };
            for (const { name, stateSetter, collectionName } of categories) {
                try {
                    const q = query(
                        collection(db, collectionName),
                        where('masterID', "==", masterID),
                        where('deleted', "==", false),
                        where("projectID", "==", currentProjectID)
                    );
                    const querySnapshot = await getDocs(q);
                    const data = querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    stateSetter(data);
                    newCanEdit[name] = data.length > 0;
                } catch (error) {
                    console.error(`${name} データの取得に失敗しました: `, error.message);
                }
            }
    
            // 最後に一括で状態を更新
            setCanEdit(newCanEdit);
        };
        fetchTableData();  
    }, [isElectricModalOpen, isNetworkModalOpen, isAirModalOpen, isWaterModalOpen]);
    
    // useEffect(() => {
    //     console.log("tab01 canEdit:", canEdit);
    //   }, [canEdit]);
      


    // 画面を開いたときに実行
        useEffect(()=>{
            if(masterID){
            }else{
            }
        }, [masterID]);
        
    return (
        <>
        <div className="header">
        </div>

        {/* <!-- 1.電気 --> */}
        <div class="container">
            <div class="title electric">
            <FontAwesomeIcon icon={faBolt} />
                電気</div>
            <button 
                type='button'
                id="modalOpenButton" 
                class="btn modalOpen tbl01" 
                onClick={()=>{
                    setElectricModalOpen(true);
                    handleNew();
                }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    {/* 新規追加 */}
            </button>
            <ModalElectric 
                isOpen={isElectricModalOpen} 
                onClose={() => setElectricModalOpen(false)}
                mode={mode} //cretate or edit　の値を出力
                selectedData={selectedData}//編集時にはデータが入る。新規の場合はnull
            />
            <TableElectric 
                data ={electricTableData}
                handleEdit={handleEdit}
            />
            <table id="tbl01" border="1" 
            >
                {/* <!-- ここにスプレッドシートの取得データが入る --> */}
            </table>
        </div>

        {/* // <!-- 2.ネットワーク --> */}
        <div class="container">
            <div class="title network">
            <FontAwesomeIcon icon={faNetworkWired} />
                ネットワーク</div>
            {/* ここ以下コピー */}
                <button 
                type='button'
                id="modalOpenButtonNetwork" 
                class="btn modalOpen tbl02" 
                onClick={()=>{
                    setNetworkModalOpen(true);
                    handleNew();
                }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    {/* 新規追加 */}
            </button>
            <ModalNetwork
                isOpen={isNetworkModalOpen} 
                onClose={() => setNetworkModalOpen(false)}
                mode={mode} //cretate or edit　の値を出力
                selectedData={selectedData}//編集時にはデータが入る。新規の場合はnull
            />
            <TableNetwork 
                data ={networkTableData}
                handleEdit={handleEdit}
            />
            <table id="tbl02" border="1" 
            >
            {/* ここより上コピー */}

                {/* <!-- ここにテーブルデータを自動生成 --> */}
            </table>
        </div>

        {/* // <!-- 3.給排気 --> */}
        <div class="container">
            <div class="title air">
            <FontAwesomeIcon icon={faWind} />
                給排気</div>
            {/* ここ以下コピー */}
            <button 
                type='button'
                id="modalOpenButtonAir" 
                class="btn modalOpen tbl03" 
                onClick={()=>{
                    setAirModalOpen(true);
                    handleNew();
                }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    {/* 新規追加 */}
            </button>
            <ModalAir
                isOpen={isAirModalOpen} 
                onClose={() => setAirModalOpen(false)}
                mode={mode} //cretate or edit　の値を出力
                selectedData={selectedData}//編集時にはデータが入る。新規の場合はnull
            />
            <TableAir 
                data ={airTableData}
                handleEdit={handleEdit}
            />
            <table id="tbl03" border="1" 
            >
                {/* ここより上コピー */}
                {/* <!-- ここにテーブルデータを自動生成 --> */}
            </table>
        </div>
        
        {/* // <!-- 4.給排水 --> */}
        <div class="container">
            <div class="title water">
            <FontAwesomeIcon icon={faDroplet} />
                給排水</div>
            {/* ここ以下コピー */}
            <button 
                type='button'
                id="modalOpenButtonWater" 
                class="btn modalOpen tbl04" 
                onClick={()=>{
                    setWaterModalOpen(true);
                    handleNew();
                }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    {/* 新規追加 */}
            </button>
            <ModalWater
                isOpen={isWaterModalOpen} 
                onClose={() => setWaterModalOpen(false)}
                mode={mode} //cretate or edit　の値を出力
                selectedData={selectedData}//編集時にはデータが入る。新規の場合はnull
            />
            <TableWater 
                data ={waterTableData}
                handleEdit={handleEdit}
            />
            <table id="tbl04" border="1" >

                {/* <!-- ここにテーブルデータを自動生成 --> */}
            </table>
            
        </div>
        </>
    );
};

export default Tab01;
